import React from "react";

const PageHeader = ({ eyebrow, title, description, actions }) => (
  <header className="cc-page-header">
    <div className="cc-page-header__text">
      {eyebrow && <p className="cc-eyebrow">{eyebrow}</p>}
      <h1 className="cc-page-title">{title}</h1>
      {description && <p className="cc-page-description">{description}</p>}
    </div>
    {actions && <div className="cc-page-header__actions">{actions}</div>}
  </header>
);

export default PageHeader;
